import { drawingStore } from "../store";

export const getSelectedGeometry = () => {
  const selectors = drawingStore.reduxStore?.selectors;
  const state = drawingStore.reduxStore?.store.getState();
  if (!state || !selectors) return;

  return selectors.getSelectedDrawing(state as never);
};
